import {useState} from 'react'
import ReportServiceFieldAllocateForm from './ReportServiceFieldAllocateForm';
import ReportServiceFieldAllocateList from './ReportServiceFieldAllocateList';

const ReportServiceFieldAllocation = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(null);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <ReportServiceFieldAllocateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <ReportServiceFieldAllocateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default ReportServiceFieldAllocation